<template>
  <div>
    <component
        :is="componentType"
        v-bind:[propAttribute]="link"
        :class="[
          'smart-block',
          {'smart-block--a': isExternalLink(link)},
          {'u-inverse': inverse},
          {'smart-block--background-image': backgroundImage},
          {'smart-block--icon-only': isIconOnly}
      ]"
        :style="[
          {backgroundColor},
          {backgroundImage},
          {backgroundBlendMode: inverse ? 'screen': 'overlay'},
      ]"
        v-on="this.popup ? {click: openPopup} : {}"
    >
      <div v-if="icon" class="smart-block__icon" :style="{backgroundImage: `url('${icon}')`}" />
      <div v-if="heading" :class="['smart-block__heading', {'smart-block__heading--smaller':heading.length > 30}]">
        {{heading}}
      </div>
    </component>
    <div class="smart-block-link-popup" v-if="isPopupShowing">
      <iframe width="100%" height="100%" class="smart-block-link-popup__iframe" :src="link" frameborder="0"></iframe>
      <button class="smart-block-link-popup__close" @click="closePopup">❌</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.smart-block-link-popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9;
}

.smart-block-link-popup__close {
  position: fixed;
  right: 2rem;
  top: 2rem;
  background: none;
  border: none;
  appearance: none;
  font-size: 2rem;
  padding: 1rem;
  z-index: 10;
  cursor: pointer;
  pointer-events: all;
}

.smart-block {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: white;
  padding: 5%;
  box-shadow: 0 1rem 1rem rgb(0 0 0 / 20%);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-image: linear-gradient(135deg, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.2));
  min-height: 120px;
  max-height: 380px;
  overflow: hidden;
  transform: translateY(-2px);
  transition: transform .3s, box-shadow .3s;

  &:hover {
    transform: translateY(0);
    box-shadow: 0 0.5rem 0.5rem rgb(0 0 0 / 20%);
  }

  &--background-image {
    background-repeat: no-repeat;
    background-size: 80%;
    background-position: center;
  }

  &--icon-only {

  }
}

.smart-block__icon {
  flex: 1;
  margin: 3%;
  display: flex;
  align-items: center;
  width: 60%;
  min-height: clamp(5rem, 6vw, 5rem);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  img {
    height: 80%;
  }

  .smart-block--icon-only & {
    margin: 0;
    width: 90%;
  }
}

.smart-block__heading {
  font-size: clamp(18px, 4vw, 38px);
  line-height: 3rem;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 2px 4px rgb(0 0 0 / 30%);

  &--smaller {
    font-size: clamp(18px, 4vw, 24px);
    line-height: 1.3rem;
    margin-top: 20px;
    min-height: 40px;
  }
}
.u-inverse {
  color: black;
}
</style>

<script>
export default {
  data() {
    return {
      isPopupShowing: false,
    }
  },
  props: {
    icon: {
      default: null,
      type: String
    },
    heading: {
      default: null,
      type: String
    },
    backgroundImage: {
      default: null,
      type: String
    },
    backgroundColor: {
      default: '#2d88bc',
      type: String
    },
    inverse: {
      default: false,
      type: Boolean
    },
    link: {
      default: '#',
      type: String
    },
    popup: {
      default: false,
      type: Boolean
    },
    isIconOnly: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    componentType() {
      if (this.popup) {
        return 'a';
      }

      return this.isExternalLink() ? 'a' : 'router-link';
    },
    propAttribute() {
      return this.isExternalLink() ? 'href' : 'to';
    }
  },
  methods: {
    isExternalLink() {
      return !this.link.startsWith('/');
    },
    openPopup(e) {
      e.preventDefault();
      this.isPopupShowing = true;
    },
    closePopup() {
      this.isPopupShowing = false;
    }
  }
}
</script>
